import React, {Component} from 'react';
import {toCardinal} from '../../utils/wind_utils';

class CustomisedDot extends Component {
  render() {
    const { cx, payload, dotType, dotValueKey, index, density, legend } = this.props;
    if (dotType !== undefined && dotType === 'Wind' && (legend || index % density === 0)) {
      const windDir = legend ? 'W' : toCardinal(payload[dotValueKey]);
      let path;
      switch (windDir) {
        case 'N':
          path = <path d="M97 224 c-4 -4 -7 -30 -7 -58 0 -39 -3 -47 -12 -38 -19 19 -28 14
-28 -16 0 -19 11 -39 35 -62 l35 -34 35 34 c24 23 35 43 35 62 0 29 -13 37
-27 16 -5 -8 -10 9 -13 42 -4 46 -8 55 -25 58 -12 2 -24 0 -28 -4z"/>;
          break;
        case 'NNE':
          path = <path d="M132 168 l-42 -43 0 29 0 29 -25 -23 c-22 -20 -25 -32 -23 -70 l3
-45 45 -3 c38 -2 50 1 70 23 l23 25 -28 0 -29 0 44 45 c37 37 41 46 30 60 -18
21 -20 20 -68 -27z"/>;
          break;
        case 'NE':
          path = <path d="M132 168 l-42 -43 0 29 0 29 -25 -23 c-22 -20 -25 -32 -23 -70 l3
-45 45 -3 c38 -2 50 1 70 23 l23 25 -28 0 -29 0 44 45 c37 37 41 46 30 60 -18
21 -20 20 -68 -27z"/>;
          break;
        case 'ENE':
          path =
            <path d="M132 168 l-42 -43 0 29 0 29 -25 -23 c-22 -20 -25 -32 -23 -70 l3
-45 45 -3 c38 -2 50 1 70 23 l23 25 -28 0 -29 0 44 45 c37 37 41 46 30 60 -18
21 -20 20 -68 -27z"/>;
          break;
        case 'E':
          path = <path d="M40 155 l-34 -35 34 -35 c26 -27 42 -35 69 -35 33 0 34 1 16 19 -17
20 -16 20 41 23 55 3 59 5 59 28 0 23 -4 25 -59 28 -57 3 -58 3 -41 23 18 18
17 19 -16 19 -27 0 -43 -8 -69 -35z"/>;
          break;
        case 'ESE':
          path = <path d="M47 193 c-4 -3 -7 -25 -7 -48 0 -31 6 -47 25 -65 l25 -23 0 28 0 29
45 -44 c42 -42 46 -43 62 -27 16 16 15 20 -27 62 l-44 45 29 0 28 0 -23 25
c-18 19 -34 25 -65 25 -23 0 -45 -3 -48 -7z"/>;
          break;
        case 'SE':
          path = <path d="M47 193 c-4 -3 -7 -25 -7 -48 0 -31 6 -47 25 -65 l25 -23 0 28 0 29
45 -44 c42 -42 46 -43 62 -27 16 16 15 20 -27 62 l-44 45 29 0 28 0 -23 25
c-18 19 -34 25 -65 25 -23 0 -45 -3 -48 -7z"/>;
          break;
        case 'SSE':
          path = <path d="M47 193 c-4 -3 -7 -25 -7 -48 0 -31 6 -47 25 -65 l25 -23 0 28 0 29
45 -44 c42 -42 46 -43 62 -27 16 16 15 20 -27 62 l-44 45 29 0 28 0 -23 25
c-18 19 -34 25 -65 25 -23 0 -45 -3 -48 -7z"/>;
          break;
        case 'S':
          path = <path d="M82 197 c-20 -21 -32 -43 -32 -60 0 -28 13 -36 27 -14 5 7 10 -10 13
-43 5 -51 7 -55 30 -55 23 0 25 4 30 55 3 33 8 50 13 43 14 -22 27 -14 27 15
0 19 -11 39 -33 60 -18 18 -35 32 -38 32 -3 0 -19 -15 -37 -33z"/>;
          break;
        case 'SSW':
          path = <path d="M80 175 l-23 -25 28 0 29 0 -44 -45 c-42 -42 -43 -46 -27 -62 16 -16
20 -15 62 27 l45 44 0 -29 0 -28 25 23 c22 20 25 32 23 70 l-3 45 -45 3 c-38
2 -50 -1 -70 -23z"/>;
          break;
        case 'SW':
          path = <path d="M80 175 l-23 -25 28 0 29 0 -44 -45 c-42 -42 -43 -46 -27 -62 16 -16
20 -15 62 27 l45 44 0 -29 0 -28 25 23 c22 20 25 32 23 70 l-3 45 -45 3 c-38
2 -50 -1 -70 -23z"/>;
          break;
        case 'WSW':
          path = <path d="M80 175 l-23 -25 28 0 29 0 -44 -45 c-42 -42 -43 -46 -27 -62 16 -16
20 -15 62 27 l45 44 0 -29 0 -28 25 23 c22 20 25 32 23 70 l-3 45 -45 3 c-38
2 -50 -1 -70 -23z"/>;
          break;
        case 'W':
          path = <path d="M115 171 c17 -20 16 -20 -41 -23 -55 -3 -59 -5 -59 -28 0 -23 4 -25
59 -28 57 -3 58 -3 41 -23 -18 -18 -17 -19 16 -19 27 0 43 8 69 35 l34 35 -34
35 c-26 27 -42 35 -69 35 -33 0 -34 -1 -16 -19z"/>;
          break;
        case 'WNW':
          path = <path d="M40 195 c-11 -14 -7 -23 30 -60 l44 -45 -29 0 -28 0 23 -25 c20 -22
32 -25 70 -23 l45 3 3 45 c2 38 -1 50 -23 70 l-25 23 0 -28 0 -29 -43 42 c-48
47 -50 48 -67 27z"/>;
          break;
        case 'NW':
          path = <path d="M40 195 c-11 -14 -7 -23 30 -60 l44 -45 -29 0 -28 0 23 -25 c20 -22
32 -25 70 -23 l45 3 3 45 c2 38 -1 50 -23 70 l-25 23 0 -28 0 -29 -43 42 c-48
47 -50 48 -67 27z"/>;
          break;
        case 'NNW':
          path = <path d="M40 195 c-11 -14 -7 -23 30 -60 l44 -45 -29 0 -28 0 23 -25 c20 -22
32 -25 70 -23 l45 3 3 45 c2 38 -1 50 -23 70 l-25 23 0 -28 0 -29 -43 42 c-48
47 -50 48 -67 27z"/>;
          break;
        default:
          break;
      }

      const svg_x = legend ? 0 : cx - 5;
      const offset_from_top = 50;

      return <svg x={svg_x} y={offset_from_top} width={10} height={10} viewBox="0 0 24.000000 24.000000"
                  preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"
           fill="#000000" stroke="none">
          {path}
        </g>
      </svg>;
    }
    return <div/>;
  }
}

export default CustomisedDot;


// WEBPACK FOOTER //
// ./src/components/graphs/CustomisedDot.js